export default {
  title: 'Chaînes',
  analytics: {
    title: 'Analytique de la chaîne',
  },
  createChannelButton: 'Créer une nouvelle chaîne',
  createChannelModalTitle: 'Créer une nouvelle chaîne',
  general: {
    on: 'sur',
    before: 'précédent',
    next: 'suivant',
    ending: 'terminer',
    media: 'medias',
    categories: 'categories',
    activate: 'activer',
    activated: 'activé',
    with: 'avec',
    without: 'sans',
    onRequest: 'sur demande',
    copy: 'Copier',
    name: 'Nom',
    emptyData: 'Aucune donnée disponible',
    send: 'Envoyer',
    modify: 'Modifier',
    personalize: 'Personnaliser',
    save: 'Enregistrer',
    title: 'Titre',
    description: 'Description',
    miniature: 'Miniature',
    favicon: 'Favicon',
    writeBelow: 'Ecrivez ci-dessous :',
    preview: 'Aperçu :',
    delete: 'Supprimer',
    activate: 'Activer',
    addItem: 'Ajouter du contenu',
    archive: 'Archiver',
    add: 'Ajouter',
  },
  emptyState: {
    title: 'Démarrez la création de votre chaîne',
    description:
      'Cette fonctionnalité vous permet de créer votre plateforme pour pouvoir la partager à votre communauté.',
    buttonText: 'Commencer',
  },
  listChannels: {
    title: 'Liste de vos chaînes',
    edit: 'Editer',
    delete: 'Supprimer',
  },
  errors: {
    createChannelFailed: 'Échec de la création de la chaîne',
    createChannelApiError: 'Erreur lors de la création de la chaîne',
  },
  onboarding: {
    firstStep: 'Premier pas',
    step1: {
      title: 'Ajoutez du contenu à votre chaîne',
      action1: 'Créez votre catégorie',
      action2: 'Ajoutez du contenu depuis votre bibliothèque',
      action3: 'Triez et organisez',
    },
    step2: {
      title: 'Gérer votre confidentialité',
      action1: "Activez ou non le système d'authentification",
      action2: 'Choisissez le mode de connexion',
      action3: "Gérez la liste des utilisateurs s'il y en a",
    },
    step3: {
      title: 'Monétisez votre contenu',
      action1: 'Activez la monétisation',
      action2: 'Attendez notre validation',
      action3: 'Créez votre compte Stripe',
      action4: 'Choisissez votre tarification',
    },
    step4: {
      title: 'Personnalisez votre chaîne',
      action1: 'Sélectionnez un thème qui correspond à vos besoins',
      action2: "Personnalisez à l'image de votre marque",
      action3: 'Visualisez le rendu de votre chaîne',
    },
  },
  details: {
    seeChannel: 'Voir la chaine',
    loading: 'Chargement de la chaîne...',
    editTheme: 'Éditer le thème',
    viewChannel: 'Voir la chaîne',
    channelId: 'ID de la chaîne',
    status: {
      online: 'En ligne',
      offline: 'Hors ligne'
    },
    error: {
      loadFailed: 'Impossible de charger les détails de la chaîne'
    },
    sections: {
      main: 'Vue d\'ensemble',
      content: 'Contenu',
      settings: 'Configuration'
    },
    menu: {
      dashboard: 'Tableau de bord',
      categories: 'Catégories',
      itemLabel: 'Contenus',
      accessRights: 'Accès / Comptes',
      sale: 'Ventes',
      analytics: 'Analytique',
      users: 'Utilisateurs',
      itemTitle: 'Tous les contenus',
      editorLabel: 'Éditeur de thème',
      paramLabel: 'Paramètres',
      stats: 'Statistiques',
    },
  },
  dashboard: {
    hoverMenu: {
      editSEO: 'Editer les informations (SEO)',
      editURL: "Modifier l'URL",
      editDesign: 'Modifier le design',
    },
    seeChannel: 'Voir la chaîne',
    latestCategories: {
      title: 'Dernières catégories',
      subtitle: 'Ajoutez des catégories pour organiser votre contenu',
      emptyState: {
        title: 'Aucune catégorie créée',
        buttonText: 'Créez une première catégorie',
      },
    },
    latestItems: {
      title: 'Derniers contenus postés',
      subtitle: 'Ajoutez du contenu pour enrichir votre chaîne',
      emptyState: {
        title: 'Aucun contenu créé',
        messageWithoutCategories1: 'Créez une première catégorie',
        messageWithoutCategories2: 'pour ajouter des contenus de votre bibliothèque.',
        messageWithCategories: 'Aucun média pour le moment',
      },
    },
    latestUsers: {
      title: 'Derniers utilisateurs créés',
      btnTitle: 'Configurez la sécurité',
    },
    monetization: {
      title: 'Vendez vos contenus',
      description:
        'Générez des revenus en monétisant votre contenu. Activez cette fonctionnalité pour proposer du contenu premium à vos abonnés.',
    },
    subscriptionMonetization: {
      title: 'Vendez vos vidéos',
      description1:
        'Vous pouvez monétiser votre chaîne en proposant des abonnements ou en vendant/louant vos vidéos à l’unité.',
      description2:
        'L’activation est gratuite. Une commission sera prélevée automatiquement sur vos ventes.',
      commissionFees: 'Frais de commission',
      percentage: '10 %',
      btnDescription:
        "Cliquez sur le bouton ci-dessous pour demander l'activation de cette option sur votre chaine.",
      tooltip: 'Il est nécessaire de publier votre chaine pour activer la monétisation.',
      btn: 'Soumettre ma demande',
    },
    stats: {
      title: 'Statistiques',
      subtitle: 'Sur les 30 derniers jours',
      tooltip: 'Voir toutes les statistiques',
    },
  },
  categories: {
    title: 'Categories',
    description:
      'Réorganisez vos catégories par glisser-déposer pour définir leur ordre ou leur arborescence.',
    btnCreateCategory: 'Créer une catégorie',
    emptyState: {
      title: 'Aucune catégorie créée',
      description: 'Cliquez sur "Créer une catégorie" pour ajouter votre première catégorie.',
    },
    editCategory: {
      btnBack: 'Retour aux catégories',
      btnAddContent: 'Ajouter un contenu',
      information: 'Informations',
      access: "Droits d'accès",
      itemsTitle: 'Contenus',
      btnDelete: 'Supprimer cette catégorie',
      info: {
        name: 'Nom',
        description: 'Description',
        url: 'URL dans la chaîne',
        parentDescription:
          "Si aucun choix n'est sélectionné ci-dessous, cette catégorie sera à la racine.",
        parentLabel: 'Catégorie parente',
        visibility: {
          title1: 'Visibilité de la catégorie',
          subtitle1:
            'En désactivant cette option, cette catégorie ne sera plus visible sur la chaîne.',
          title2: "Afficher sur la page d'accueil",
          subtitle2:
            "En désactivant cette option, cette catégorie ne sera plus visible sur la page d'accueil de la chaîne.",
          title3: 'Afficher dans la barre de navigation',
          subtitle3:
            'En désactivant cette option, cette catégorie ne sera plus visible dans la barre de navigation.',
        },
      },
      accessRights: {
        description1: "Les droits d'accès définis ici s'appliqueront à toutes les vidéos",
        description2: 'Non répertoriée',
        description3: 'de cette catégorie.',
        description4:
          "Vous pouvez également définir des droits d'accès sur chaque vidéo de cette catégorie.",
        description5:
          "Si vous ajoutez une nouvelle vidéo dans cette catégorie, elle héritera automatiquement des droits d'accès définis ici.",
        description6:
          "À noter que les droits s'appliquent uniquement sur les vidéos de cette catégorie et non sur les sous-catégories.",
        btnAddAccessRight: "Ajouter un droit d'accès",
        user: 'Utilisateur',
        group: 'Groupe',
        title1: 'Utilisateur / Groupe',
        title2: 'Type',
        modal: {
          title: "Autoriser l'accès à ce contenu",
          users: 'Utilisateurs',
          groups: 'Groupes',
          search: 'Rechercher un email',
          emptyStateUser: 'Aucun utilisateur disponible',
          emptyStateGroup: 'Aucun groupe disponible',
          save: 'Enregistrer',
          email: 'Email',
        },
      },
      items: {
        emptyState: 'Aucun contenu dans cette catégorie',
        btnDeleteSelected: 'Supprimer la sélection',
        preview: 'prévisualisation',
        public: 'Public',
        private: 'Privé',
        notListed: 'Non répertorié',
        paid: 'Payante',
        videoSorting: 'Tri des vidéos',
        videoSortingText:
          "Choisissez l'ordre d'affichage des vidéos de cette catégorie dans la chaîne.",
        name: 'Nom',
        publishedOn: 'Publié le',
        visibility: 'Visibilité',
        manualSorting: 'Tri manuel',
      },
    },
  },
  items: {
    title: 'Tous les contenus',
    btnAddItem: 'Ajouter un contenu',
    tooltip: "Créez votre première catégorie avant d'ajouter un contenu",
    searchPlaceholder: 'Rechercher un contenu',
    filterByCategory: 'Catégorie',
    filterByType: 'Type',
    filterByVisibility: 'Visibilité',
    noSearchResults: 'Aucun contenu trouvé',
    tryDifferentSearch: 'Essayez d\'ajuster vos filtres ou termes de recherche',
    emptyState: 'Aucun contenu publié',
    emptyDescription: 'Commencez par ajouter du contenu de votre bibliothèque à cette chaîne',
    btnAdd: 'Ajouter du contenu',
    premium: 'Premium',
    deleteTitle: 'Supprimer le contenu',
    deleteMessage: 'Êtes-vous sûr de vouloir retirer "{title}" de cette chaîne ?',
    table: {
      title: 'Titre',
      publishedAt: 'Publié le',
      views: 'Vues',
    },
    types: {
      video: 'Vidéo',
      image: 'Image',
      audio: 'Audio',
      document: 'Document',
      collection: 'Collection',
    },
    visibility: {
      public: 'Public',
      authenticated: 'Authentifié',
      restricted: 'Restreint',
    },
    description1:
      'Retrouvez ci-dessous la liste des contenus de votre bibliothèque que vous avez publié sur votre chaîne.',
    description2:
      "Éditez les catégories de chaque contenu ainsi que leurs droits d'accès en cliquant sur l'icône.",
    item: {
      menu: {
        mediabox: 'Voir dans Médiabox',
        statistics: 'Voir les statistiques',
      },
      alertMonetization:
        'Ce contenu est accessible gratuitement sur votre chaîne. Pour le vendre, activez la monétisation.',
      informations: {
        title: 'Informations',
        publishedAt: 'Date de publication',
        category: 'Catégorie',
        url: 'URL',
      },
      subscription: {
        title: 'Abonnement',
        switch1: "Disponible sur l'ensemble de vos abonnements.",
        switch2: 'Afficher une prévisualisation de ce contenu aux utilisateurs non abonnés.',
        subscriptionName: "Nom de l'abonnement",
      },
      pricing: {
        title: 'Tarifs',
        priceSelect: 'Sélectionnez un tarif',
      },
      access: {
        title: 'Accès',
        allowDownload: 'Autoriser le téléchargement du média.',
        restrictAccess: "Restreindre l'accès à ce contenu",
        whoCanAccess: 'Qui peut accéder à ce contenu ?',
        public: 'Public',
        auth: 'Authentifié',
        restricted: 'Accès restreint',
        publicAlert: 'Ce contenu est accessible par toute personne qui se rend sur votre chaîne.',
        authAlert: 'Ce contenu est accessible uniquement aux utilisateurs authentifiés.',
        restrictedAlert:
          'Ce contenu est accessible uniquement aux utilisateurs authentifiés sélectionnés ci-dessous.',
        btnAddAccessRight: "Ajouter un droit d'accès",
        previewLabel: 'Autoriser les utilisateurs non authentifiés à voir un aperçu de ce contenu',
      },
    },
  },
  users: {
    title: 'Comptes utilisateurs',
    btnInvite: 'Inviter des utilisateurs',
    btnCreateGroup: 'Créer un groupe',
    description:
      "Classez  vos utilisateurs par groupe afin de simplifier la gestion des droits d'accès à vos contenus",
    searchPlaceholder: 'Rechercher un utilisateur',
    filterByGroup: 'Filtrer par groupe',
    filterByStatus: 'Filtrer par statut',
    deleteConfirmTitle: 'Supprimer l\'utilisateur',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.',
    reactivateSuccess: 'Utilisateur réactivé avec succès',
    reactivateError: 'Erreur lors de la réactivation',
    deleteSuccess: 'Utilisateur supprimé avec succès',
    deleteError: 'Erreur lors de la suppression',
    updateSuccess: 'Utilisateur mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour',
    showInviteLink: 'Afficher le lien d\'invitation',
    resendInvitation: 'Renvoyer l\'invitation',
    noSearchResults: 'Aucun utilisateur trouvé',
    tryDifferentSearch: 'Essayez d\'ajuster vos filtres ou votre recherche',
    emptyDescription: 'Commencez par inviter des utilisateurs à votre chaîne',
    emptyState: {
      users: 'Aucun utilisateur',
      groups: 'Aucun groupe pour le moment',
    },
    tabs: {
      users: 'Utilisateurs',
      groups: 'Groupes',
      invites: "Liens d'invitation",
      information: 'Informations générales',
      access: "Droits d'accès",
      statistics: 'Statistiques',
    },
    table: {
      email: 'Email',
      name: 'Nom',
      groups: 'Groupes',
      joinedAt: 'Rejoint le',
    },
    badges: {
      inactive: 'Inactif',
      staff: 'Staff',
      owner: 'Propriétaire',
    },
    status: {
      all: 'Tous',
      active: 'Actifs',
      inactive: 'Inactifs',
    },
    usersTab: {
      description:
        "Classez  vos utilisateurs par groupe afin de simplifier la gestion de droits d'accès à vos contenus",
      btnExport: 'Exporter (.xlsx)',
      btnInvite: 'Envoyer des invitations',
      searchPlaceholder: 'Rechercher un utilisateur',
      filterAll: 'Tout',
      filterRegistered: 'Inscrits',
      filterPending: 'En attente',
      table: {
        email: 'Email',
        lastName: 'Nom',
        firstName: 'Prénom',
        createdAt: 'Invité le',
        copyLink: "Copier le lien d'invitation",
        resendInvitation: 'Envoyer à nouveau une invitation',
        viewUser: 'Voir cet utilisateur',
        btnDeleteSelected: 'Supprimer cet utilisateur',
        menu: {
          edit: 'Modifier',
          resend: 'Renvoyer',
          link: "Lien d'invitation",
          pendingStatus: 'En attente',
        },
      },
      modal: {
        title: 'Inviter des utilisateurs',
        description:
          'Les emails ajoutés dans cette liste recevront automatiquement une invitation pour créer leur compte sur la chaîne.',
        text1: 'Copiez-collez la liste des emails ci-dessous',
        text2:
          'Vous pouvez copier-coller une liste complète, même avec des informations inutiles, nous allons la filtrer pour récupérer uniquement les emails.',
        title2: 'Associez ces utilisateurs à un groupe',
        description2:
          "Les utilisateurs d'un même groupe partagent les mêmes propriétés. Lorsque vous invitez de nombreux utilisateurs, il est conseillé de les ajouter dans un groupe pour simplifier votre organisation par la suite.",
        selectGroup: 'Sélectionnez un ou plusieurs groupes',
        title3: 'Expiration des comptes utilisateurs',
        description3:
          'Vous pouvez définir une date à laquelle les comptes des utilisateurs ci-dessous seront désactivés. Ces utilisateurs ne pourront donc plus se connecter à votre chaîne.',
        noExpiration: 'Aucune expiration définie',
      },
    },
    pickers: {
      groups: {
        placeholder: 'Sélectionner des groupes',
        noResults: 'Aucun groupe trouvé',
        typeToSearch: 'Tapez pour rechercher des groupes',
      },
    },
    groups: {
      table: {
        name: 'Nom',
        description: 'Description',
        usersCount: "Nombre d'utilisateurs",
      },
      emptyDescription: 'Créez des groupes pour gérer les permissions de vos utilisateurs',
      noSearchResults: 'Aucun groupe trouvé',
      tryDifferentSearch: 'Essayez un autre terme de recherche',
      deleteTitle: 'Supprimer le groupe',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer ce groupe ? Cette action est irréversible.',
      deleteSuccess: 'Le groupe a été supprimé avec succès',
      deleteError: 'Erreur lors de la suppression',
      deleteErrorMessage: 'Impossible de supprimer le groupe. Veuillez réessayer.',
      createError: 'Erreur lors de la création',
      createErrorMessage: 'Impossible de créer le groupe. Veuillez réessayer.',
      createModal: {
        title: 'Créer un groupe',
        nameLabel: 'Nom du groupe',
        namePlaceholder: 'Ex: Équipe Marketing',
        descriptionLabel: 'Description (optionnel)',
        descriptionPlaceholder: 'Décrivez le rôle ou l\'objectif de ce groupe...',
        nameRequired: 'Le nom du groupe est requis',
        nameTooShort: 'Le nom doit contenir au moins 2 caractères',
        nameTooLong: 'Le nom ne peut pas dépasser 100 caractères',
      },
      newGroup: 'Nouveau groupe',
      addMembers: 'Ajouter des membres',
      noMembers: 'Aucun membre dans ce groupe',
      addFirstMember: 'Ajouter le premier membre',
      saveGroupFirst: 'Enregistrez le groupe pour activer cet onglet',
      memberRemovedSuccess: 'Membre retiré avec succès',
      membersAddedSuccess: '{count} membre(s) ajouté(s) avec succès',
      invalidForm: 'Veuillez remplir tous les champs requis',
      createSuccess: 'Groupe créé avec succès',
      updateSuccess: 'Groupe mis à jour avec succès',
      updateError: 'Erreur lors de la mise à jour du groupe',
      removeMemberTitle: 'Retirer le membre',
      removeMemberMessage: 'Êtes-vous sûr de vouloir retirer {name} du groupe ?',
      removeMemberError: 'Erreur lors de la suppression du membre',
      accessComingSoon: 'La gestion des accès aux contenus sera bientôt disponible',
      tabs: {
        information: 'Informations',
        members: 'Membres',
        access: 'Accès',
      },
      fields: {
        name: 'Nom du groupe',
        namePlaceholder: 'Ex: Équipe Marketing',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez le rôle ou l\'objectif de ce groupe...',
        isActive: 'Groupe actif',
      },
      sections: {
        information: {
          title: 'Informations',
          description: 'Nom et description du groupe.',
        },
        members: {
          title: 'Membres',
          description: 'Utilisateurs dans ce groupe.',
        },
        access: {
          title: 'Accès aux contenus',
          description: 'Contenus accessibles par ce groupe et gestion des accès.',
        },
      },
      table: {
        member: 'Membre',
        joinedAt: 'Date d\'ajout',
      },
      groupDetails: {
        btnAddUsers: 'Ajouter des utilisateurs',
        informations: 'Informations',
        groupeName: 'Nom du groupe',
        groupeNamePlaceholder: 'Entrez le nom du groupe',
        expirationDate: "Date d'expiration",
        expirationDatePlaceholder: 'Expiration du groupe',
        noExpiration: "Pas de date d'expiration",
        usersList: 'Liste des utilisateurs',
        emptyGroup: 'Aucun utilisateur dans ce groupe',
        table: {
          email: 'Email',
          firstName: 'Prénom',
          lastName: 'Nom',
          createdAt: "Date d'inscription",
        },
        addUsersModal: {
          title: 'Ajouter des utilisateurs',
          searchUser: 'Rechercher un utilisateur',
          noUsers: 'Aucun utilisateur',
          email: 'Email',
          lastName: 'Nom',
          firstName: 'Prénom',
        },
      },
    },
    userSelectionModal: {
      title: 'Sélectionner des utilisateurs',
      searchPlaceholder: 'Rechercher par nom ou email...',
      noUsersFound: 'Aucun utilisateur trouvé',
      tryDifferentSearch: 'Essayez un autre terme de recherche',
      noAvailableUsers: 'Aucun utilisateur disponible à ajouter',
      user: 'Utilisateur',
      joinedAt: 'Inscrit',
      lastActivity: 'Dernière activité',
      owner: 'Propriétaire',
      staff: 'Staff',
      inactive: 'Inactif',
      addUser: 'Ajouter l\'utilisateur',
      addUsers: 'Ajouter {count} utilisateurs',
    },
  },
  monetization: {
    subscriptions: {
      title: 'Abonnements',
      newSubscription: 'Nouvel Abonnement',
      btnCreate: 'Créer un Abonnement',
      searchPlaceholder: 'Rechercher des abonnements...',
      filterByStatus: 'Filtrer par statut',
      filterByPeriod: 'Filtrer par période',
      noSearchResults: 'Aucun abonnement trouvé',
      tryDifferentSearch: 'Essayez d\'ajuster vos filtres ou termes de recherche',
      deleteTitle: 'Supprimer l\'Abonnement',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer l\'abonnement "{name}" ? Cette action est irréversible.',
      createError: 'Échec de la création de l\'abonnement',
      updateError: 'Échec de la mise à jour de l\'abonnement',
      deleteError: 'Échec de la suppression de l\'abonnement',
      noSubscriptions: 'Aucun abonnement',
      noSubscriptionsDescription: 'Créez votre premier abonnement pour commencer à monétiser votre contenu.',
      createFirstSubscription: 'Créer le Premier Abonnement',
      table: {
        name: 'Nom',
        price: 'Prix',
        subscribers: 'Abonnés',
        createdAt: 'Créé le',
        status: 'Statut',
      },
      status: {
        all: 'Tous',
        active: 'Actif',
        inactive: 'Inactif',
      },
      periods: {
        all: 'Toutes les périodes',
        monthly: 'Mensuel',
        yearly: 'Annuel',
        weekly: 'Hebdomadaire',
      },
      headers: {
        name: 'Nom',
        price: 'Prix',
        period: 'Période',
        subscribers: 'Abonnés',
        status: 'Statut',
      },
      tabs: {
        information: 'Informations',
        items: 'Contenu',
        subscribers: 'Abonnés',
      },
      sections: {
        information: {
          title: 'Détails de l\'Abonnement',
          description: 'Configurez le nom, le prix et les paramètres de l\'abonnement.',
        },
        items: {
          title: 'Contenu de l\'Abonnement',
          description: 'Gérez le contenu disponible pour les abonnés de ce plan.',
        },
        subscribers: {
          title: 'Abonnés',
          description: 'Visualisez et gérez les utilisateurs abonnés à ce plan.',
        },
      },
    },
    prices: {
      title: 'Tarifs',
      newPrice: 'Nouveau Tarif',
      deleteTitle: 'Supprimer le Tarif',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer ce tarif ? Cette action est irréversible.',
      createError: 'Échec de la création du tarif',
      updateError: 'Échec de la mise à jour du tarif',
      deleteError: 'Échec de la suppression du tarif',
      noPrices: 'Aucun tarif',
      noPricesDescription: 'Créez votre premier tarif pour commencer à vendre du contenu individuel.',
      createFirstPrice: 'Créer le Premier Tarif',
    },
    coupons: {
      title: 'Codes Promo',
      description: 'Créez des codes de réduction pour offrir des promotions spéciales à vos clients.',
      btnCreate: 'Créer un Code Promo',
      newCoupon: 'Nouveau Code Promo',
      searchPlaceholder: 'Rechercher des codes promo...',
      filterByStatus: 'Filtrer par statut',
      noSearchResults: 'Aucun code promo trouvé',
      tryDifferentSearch: 'Essayez d\'ajuster vos filtres ou termes de recherche',
      createError: 'Échec de la création du code promo',
      updateError: 'Échec de la mise à jour du code promo',
      deleteError: 'Échec de la suppression du code promo',
      deleteTitle: 'Supprimer le Code Promo',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer le code promo "{code}" ? Cette action est irréversible.',
      noCoupons: 'Aucun code promo',
      noCouponsDescription: 'Créez votre premier code promo pour offrir des réductions à vos clients.',
      createFirstCoupon: 'Créer le Premier Code Promo',
      searchUsage: 'Rechercher dans l\'historique...',
      export: 'Exporter',
      noUsage: 'Aucune utilisation',
      noUsageDescription: 'Ce code promo n\'a pas encore été utilisé.',
      expired: 'Expiré',
      maxReached: 'Limite atteinte',
      unlimited: 'Illimité',
      noExpiration: 'Pas d\'expiration',
      table: {
        code: 'Code',
        discount: 'Réduction',
        usage: 'Usage',
        expiry: 'Expiration',
        status: 'Statut',
      },
      status: {
        all: 'Tous',
        active: 'Actif',
        inactive: 'Inactif',
        expired: 'Expiré',
      },
      daysLeft: '{days} jours restants',
      headers: {
        code: 'Code',
        discount: 'Réduction',
        usage: 'Utilisation',
        expiry: 'Expiration',
        status: 'Statut',
      },
      tabs: {
        information: 'Informations',
        usage: 'Historique d\'Utilisation',
      },
      sections: {
        information: {
          title: 'Détails du Code Promo',
          description: 'Configurez le code de réduction et ses limites d\'utilisation.',
        },
        statistics: {
          title: 'Statistiques d\'Utilisation',
          description: 'Aperçu de l\'utilisation de ce code promo.',
        },
        usage: {
          title: 'Historique d\'Utilisation',
          description: 'Liste détaillée de tous les clients qui ont utilisé ce code promo.',
        },
      },
      fields: {
        code: 'Code Promo',
        codePlaceholder: 'ex: ETE20',
        codeHint: 'Caractères alphanumériques, tirets et underscores uniquement',
        discountType: 'Type de Réduction',
        discountValue: 'Valeur de la Réduction',
        currency: 'Devise',
        usageLimits: 'Limites d\'Utilisation',
        limitTotalUsage: 'Limiter le nombre total d\'utilisations',
        limitPerCustomer: 'Limiter les utilisations par client',
        maxRedemptionsPlaceholder: 'ex: 100',
        maxPerCustomerPlaceholder: 'ex: 1',
        expiration: 'Expiration',
        setExpiration: 'Définir une date d\'expiration',
        isActive: 'Code promo actif',
      },
      types: {
        percentage: 'Pourcentage',
        fixedAmount: 'Montant Fixe',
      },
      validation: {
        codeRequired: 'Le code promo est requis',
        codeTooLong: 'Le code doit faire 50 caractères maximum',
        codeTooShort: 'Le code doit faire au moins 3 caractères',
        codeInvalid: 'Le code ne peut contenir que des lettres, chiffres, tirets et underscores',
        valueRequired: 'La valeur de réduction est requise',
        valuePositive: 'La valeur doit être supérieure à zéro',
        percentMax: 'Le pourcentage ne peut pas dépasser 100%',
      },
      stats: {
        totalUsage: 'Utilisations Totales',
        totalDiscount: 'Réductions Totales Accordées',
        remainingUsage: 'Utilisations Restantes',
        expiresIn: 'Expire Dans',
      },
      table: {
        user: 'Client',
        date: 'Date',
        subscription: 'Abonnement',
        discount: 'Réduction',
        finalPrice: 'Prix Final',
      },
    },
  },
  sale: {
    tabs: {
      subscription: 'Abonnements',
      tarif: 'Tarifs',
      promo: 'Codes promotionnels',
    },
    subscription: {
      description: 'Créez vos abonnements et liez-les à vos différentes catégories et contenus.',
      btnCreate: 'Créer un abonnement',
      headers: {
        name: 'Nom',
        tarif: 'Tarif',
        createdAt: 'Créer le',
        activeSubscribers: 'Abonnés actifs',
        status: 'Etat',
      },
      deleteModal: {
        title: 'Supprimer cet abonnement',
        description:
          'Êtes-vous sûr de vouloir supprimer cet abonnement ? Cette action est irréversible.',
      },
      details: {
        tabs: {
          informations: 'Informations',
          subscribers: 'Abonnés',
          items: 'Contenus',
        },
        informations: {
          draftMode: 'Mode Brouillon',
          activated: 'activé',
          desactivated: 'désactivé',
          draftActivatetext:
            "Cet abonnement est actuellement en mode brouillon, il n'est pas encore publié ni accessible aux utilisateurs.",
          draftDesactivateText: 'Cet abonnement est publié et accessible aux utilisateurs.',
          subscriptionName: "Nom de l'abonnement",
          description: 'Description',
          descriptionPlaceholder: "Description de l'abonnement",
          image: 'Image',
          subscriptionType: "Type d'abonnement",
          recurrent: 'Récurrent',
          punctual: 'Ponctuel',
          tariff: 'Tarif',
          tariffPlaceholder: 'Prix en €',
          billingPeriod: 'Période de facturation',
          autoRenewal: 'Renouvellement automatique',
          trialPeriod: "Période d'essai",
          noTrialPeriod: "Aucune période d'essai",
          restrictAccess: "Restreindre l'accès à cet abonnement",
          restrictAccessText:
            "Seuls les utilisateurs qui renseigneront le mot de passe ci-dessous pourront souscrire à l'abonnement. Par défaut, tous les utilisateurs peuvent souscrire à cet abonnement.",
          password: 'Mot de passe',
          period: {
            monthly: 'Mensuelle',
            quarterly: 'Trimestrielle',
            yearly: 'Annuelle',
            halfYearly: 'Semestrielle',
            month: 'Mois',
            day: 'Jour',
            days: 'Jours',
            custom: 'Personnalisée',
            all: 'Tous les',
          },
        },
      },
    },
    tarif: {
      description:
        'Créez vos tarifs et sélectionnez dans les contenus le tarif que vous voulez associer à votre média.',
      btnCreate: 'Créer un nouveau tarif',
      headers: {
        name: 'Nom',
        tarif: 'Tarif',
        period: 'Période',
        download: 'Téléchargement',
      },
      deleteModal: {
        title: 'Supprimer ce tarif',
        description: 'Êtes-vous sûr de vouloir supprimer ce tarif ? Cette action est irréversible.',
      },
    },
    promo: {
      description:
        'Un bon de réduction peut être utilisé pour offrir une remise à un client lors du règlement.',
      btnCreate: 'Créer un bon de réduction',
      headers: {
        code: 'Code',
        reduction: 'Réduction',
        use: 'Utilisations',
        expiresAt: 'Expire le',
      },
      deleteModal: {
        title: 'Supprimer ce bon de réduction',
        description:
          'Êtes-vous sûr de vouloir supprimer ce bon de réduction ? Cette action est irréversible.',
      },
    },
  },
  domain: {
    title: 'Domaines de la chaîne',
    description:
      'Gérez les domaines de votre chaîne. Votre chaîne sera accessible depuis le domaine principal.',
    primaryDomain: 'Domaine principal',
    secondaryDomains: 'Domaines secondaires',
    noPrimaryDomain: 'Aucun domaine principal configuré. Ajoutez un domaine pour commencer.',
    noDomainsTitle: 'Aucun domaine configuré',
    noDomainsDesc:
      'Commencez par ajouter un sous-domaine Videas ou votre domaine personnalisé pour rendre votre chaîne accessible en ligne.',
    addDomain: 'Ajouter un domaine',
    addFirstDomain: 'Ajouter votre premier domaine',
    aboutPrimaryDomain: 'À propos du domaine principal',
    primaryDomainInfo:
      "Le domaine principal est l'URL principale où votre chaîne est accessible. Les domaines secondaires redirigent vers le domaine principal.",
    sslCertificates: 'Certificats SSL',
    sslInfo:
      'Tous les domaines sont automatiquement sécurisés avec des certificats SSL pour des connexions chiffrées.',
    needHelp: "Besoin d'aide ?",
    helpDescription:
      'Notre équipe de support est là pour vous aider à configurer vos domaines personnalisés.',
    contactSupport: 'Contacter le support',

    // Custom domain banner
    customDomainBanner: {
      title: 'Boostez votre marque avec un domaine personnalisé',
      description:
        'Passez au niveau supérieur avec votre propre nom de domaine professionnel. Démarquez-vous et renforcez la confiance de votre audience.',
      cta: 'Obtenir un domaine personnalisé',
      pricing: 'À partir de 10€/mois',
      benefits: {
        professional: 'Apparence professionnelle',
        branding: 'Renforce votre marque',
        seo: 'Meilleur référencement',
        trust: 'Inspire confiance',
      },
    },

    // Domain card
    primary: 'Principal',
    default: 'Par défaut',
    status: {
      active: 'Actif',
      pending: 'En attente',
      error: 'Erreur',
    },
    dnsPending: 'Configuration DNS requise',
    viewDnsInstructions: 'Voir les instructions DNS',
    configureNow: 'Configurer maintenant',
    configureDns: 'Configurer le DNS',
    pendingMessage: 'La configuration DNS est en attente. Veuillez configurer vos enregistrements DNS pour activer ce domaine.',
    checkNow: 'Vérifier maintenant',
    verifiedAt: 'Vérifié le {date}',
    sslActive: 'Actif',
    sslPending: 'En attente',
    makePrimary: 'Définir comme principal',
    checkStatus: 'Vérifier le statut',
    remove: 'Supprimer',

    // Delete domain modal
    deleteDomain: {
      title: 'Supprimer le domaine',
      warning: 'Cette action est définitive et ne peut pas être annulée',
      consequences: 'La suppression de ce domaine rendra immédiatement votre chaîne inaccessible à cette adresse.',
      domainLabel: 'Domaine à supprimer',
      importantTitle: 'Important',
      consequence1: 'Votre chaîne ne sera plus accessible à cette adresse',
      consequence2: 'Tous les liens partagés avec ce domaine cesseront de fonctionner',
      consequence3: 'Vous pourrez ajouter ce domaine à nouveau plus tard si nécessaire',
      confirmLabel: 'Je comprends les conséquences et souhaite supprimer ce domaine',
      deleteButton: 'Supprimer le domaine'
    },

    // Add domain modal
    chooseDomainType: 'Choisissez votre type de domaine',
    videasSubdomain: 'Sous-domaine Videas',
    videasSubdomainDesc: 'Rapide et gratuit - utilisez un sous-domaine sur videastv.com',
    customDomain: 'Domaine personnalisé',
    customDomainDesc: 'Utilisez votre propre nom de domaine pour une apparence professionnelle',
    customDomainPricing: {
      title: 'Abonnement mensuel',
      price: '10€/mois',
      description: 'Facturé mensuellement sur votre abonnement',
      included: 'Certificat SSL, configuration DNS automatique et support 24/7 inclus'
    },
    subdomainPlaceholder: 'ma-chaine',
    customDomainPlaceholder: 'exemple.com ou video.exemple.com',
    preview: 'Aperçu',
    rootDomain: 'Domaine racine',
    subdomain: 'Sous-domaine',
    stepChoose: 'Choisir le domaine',
    stepReview: 'Vérifier et confirmer',
    reviewTitle: 'Vérifiez votre configuration',
    domainLabel: 'Domaine',
    typeLabel: 'Type',
    rootDomainInfo: 'Domaine racine (nécessite un enregistrement A)',
    subdomainInfo: 'Sous-domaine (nécessite un enregistrement CNAME)',
    instantActivation: 'Ce domaine sera activé immédiatement !',
    nextSteps: 'Prochaines étapes',
    step1Title: 'Configurer le DNS',
    step1Desc: 'Ajoutez les enregistrements DNS requis chez votre fournisseur de domaine',
    step2Title: 'Attendre la propagation',
    step2Desc: "Les changements DNS peuvent prendre jusqu'à 24 heures pour se propager",
    step3Title: 'Activation automatique',
    step3Desc: 'Votre domaine sera automatiquement activé une fois le DNS vérifié',
    activate: 'Activer',
    addAndConfigure: 'Ajouter et configurer',
    setPrimaryLabel: 'Définir comme domaine principal',
    setPrimaryDescription: 'Votre chaîne sera principalement accessible depuis ce domaine. Les autres domaines redirigeront vers celui-ci.',
    subdomainRequired: 'Le sous-domaine est requis',
    maxLength: 'Maximum {max} caractères',
    slugFormat: 'Utilisez uniquement des lettres minuscules, des chiffres et des tirets',
    domainRequired: 'Le domaine est requis',
    invalidDomain: 'Format de domaine invalide',

    // DNS instructions modal
    dnsConfiguration: 'Configuration DNS',
    dnsConfigured: 'Le DNS est correctement configuré !',
    dnsInstructionsTitle: 'Configurez vos enregistrements DNS',
    dnsInstructionsDesc:
      'Ajoutez les enregistrements DNS suivants chez votre fournisseur de domaine pour activer votre domaine personnalisé.',
    requiredRecords: 'Enregistrements DNS requis',
    recordType: 'Type',
    recordName: 'Nom/Hôte',
    recordValue: 'Valeur',
    recordTTL: 'TTL',
    copiedToClipboard: 'Copié dans le presse-papiers !',
    providerInstructions: 'Instructions spécifiques au fournisseur',
    otherProvider: 'Autre',
    ovh: {
      step1: 'Connectez-vous à votre manager OVH',
      step2: 'Accédez à la section zone DNS',
      step3: 'Ajoutez les enregistrements indiqués ci-dessus',
      step4: 'Enregistrez et attendez la propagation',
    },
    cloudflare: {
      step1: 'Connectez-vous à votre tableau de bord Cloudflare',
      step2: 'Sélectionnez votre domaine',
      step3: 'Allez dans les paramètres DNS et ajoutez les enregistrements',
      step4: 'Assurez-vous que le proxy est désactivé pour ces enregistrements',
    },
    gandi: {
      step1: 'Connectez-vous à votre compte Gandi',
      step2: 'Accédez à la section des enregistrements DNS',
      step3: 'Ajoutez les enregistrements comme indiqué',
      step4: 'Activez les modifications',
    },
    genericInstructions:
      'Connectez-vous au panneau de contrôle de votre fournisseur de domaine et ajoutez les enregistrements DNS indiqués ci-dessus. Les étapes exactes varient selon le fournisseur.',
    verification: 'Vérification',
    propagationInfo:
      "La propagation DNS peut prendre jusqu'à 24 heures. Nous vérifierons et activerons automatiquement votre domaine.",
    checkDns: 'Vérifier le DNS',
    dnsChecker: 'Outil de vérification DNS',
    lastCheck: 'Dernière vérification : {time}',
    configurationComplete: 'Configuration terminée !',
    dnsActive: 'Enregistrements DNS vérifiés',
    domainReady: 'Votre domaine est prêt à être utilisé',

    // Old keys below for compatibility
    subtitle:
      'Choisissez le lien à laquelle votre chaîne sera disponible en utilisant une adresse gratuite fournie par Videas ou liez votre site à votre propre nom de domaine.',
    subtitle:
      'Choisissez le lien à laquelle votre chaîne sera disponible en utilisant une adresse gratuite fournie par Videas ou liez votre site à votre propre nom de domaine.',
    domainVideas: 'Utilisez un de nos domaines personnalisées',
    domainVideasText:
      "Vous pouvez utiliser notre domaine videastv.com, si vous n'avez pas encore votre propre nom de domaine.",
    domainVideasAlert:
      "Attention, si vous modifiez l'URL, votre chaîne sera indisponible à l'ancienne URL. Si vous avez déjà partagé le précédent lien, ce dernier ne sera plus valide.",
    domainCustom: 'Votre propre nom de domaine',
    domainCustomText:
      "Donnez à votre chaîne une apparence plus professionnelle en la mettant sur votre propre domaine plutôt que d'utiliser un domaine en videastv.com.\nContactez-nous pour configurer votre domaine.",
    domainCustomized: 'Domaine personnalisé',
    domainCustomizedText:
      'Vous utilisez un nom de domaine personnalisé pour cette chaîne.\nPour toute modification, merci de contacter le support.',
    customDomain: {
      title: "Personnalisez l'URL de votre chaîne",
      description1:
        "Vous disposez d'un nom de domaine et vous souhaitez faire pointer votre chaîne vers ce nom de domaine ou vers un sous-domaine ?",
      description2:
        'Cette option est facturée et sera ajoutée automatiquement à votre abonnement actuel.',
      monthlySubscription: 'Abonnement mensuel',
      monthlySubscriptionText: 'Nom de domaine personnalisé',
      monthlySubscriptionTarif: '10 € / mois',
      indicateUrl: "Indiquez ci-dessous l'URL complète que vous souhaitez pour votre chaîne :",
      label: 'URL de ma chaine',
      btnDescription:
        "Cliquez sur le bouton ci-dessous pour demander l'activation de cette option sur votre chaine. Notre équipe reviendra vers vous dans les plus bref délais avec la configuration à faire au niveau de votre zone DNS.",
      tooltip:
        'Il est nécessaire de publier votre chaine pour activer le nom de domaine personnalisé.',
      btnSubmit: 'Soumettre ma demande',
    },
  },

  monetization: {
    landing: {
      title: 'Commencez à Monétiser Votre Contenu',
      subtitle: 'Transformez vos vidéos en revenus avec notre solution de monétisation simple et transparente',
      startButton: 'Démarrer l\'Activation',
      features: {
        commission: {
          title: 'Commission Simple',
          description: 'Seulement 10% sur vos ventes, sans frais cachés'
        },
        secure: {
          title: 'Paiements Sécurisés',
          description: 'Propulsé par Stripe pour une sécurité maximale'
        },
        instant: {
          title: 'Configuration Rapide',
          description: 'Commencez à vendre en quelques minutes'
        },
        analytics: {
          title: 'Analyses Détaillées',
          description: 'Suivez vos performances en temps réel'
        }
      },
      pricing: {
        title: 'Tarification Simple et Transparente',
        commission: {
          title: 'Commission Videas',
          description: 'Sur chaque transaction',
          features: {
            noSetupFees: 'Aucun frais d\'installation',
            noMonthlyFees: 'Pas d\'abonnement mensuel',
            payAsYouEarn: 'Payez uniquement quand vous vendez'
          }
        },
        stripe: {
          title: 'Frais Stripe',
          fees: '1,5% + 0,25€',
          description: 'Par transaction',
          features: {
            securePayments: 'Traitement sécurisé des paiements',
            globalReach: 'Acceptez les paiements du monde entier',
            automaticTaxes: 'Calcul automatique des taxes'
          }
        },
        example: {
          title: 'Exemple',
          description: 'Pour une vente de 100€, vous recevez 88,25€ après tous les frais'
        }
      },
      howItWorks: {
        title: 'Comment Ça Marche',
        step: 'Étape',
        steps: {
          configure: {
            title: 'Configurez Vos Paramètres',
            description: 'Choisissez votre devise et vos options de paiement'
          },
          connectStripe: {
            title: 'Connectez Stripe',
            description: 'Liez votre compte Stripe pour recevoir les paiements'
          },
          setPrices: {
            title: 'Définissez Vos Prix',
            description: 'Créez des tarifs et abonnements pour votre contenu'
          },
          startSelling: {
            title: 'Commencez à Vendre',
            description: 'Votre chaîne est prête à générer des revenus'
          }
        }
      },
      faq: {
        title: 'Questions Fréquentes',
        items: {
          whenPaid: {
            question: 'Quand vais-je recevoir mes paiements ?',
            answer: 'Les paiements sont traités par Stripe et transférés sur votre compte bancaire selon votre calendrier de paiement Stripe, généralement sous 2 à 7 jours ouvrables.'
          },
          whatFees: {
            question: 'Quels sont les frais totaux ?',
            answer: 'Les frais totaux sont de 10% de commission Videas + les frais de traitement Stripe (1,5% + 0,25€ par transaction). Aucun frais caché ni charges mensuelles.'
          },
          canChangePrice: {
            question: 'Puis-je modifier mes prix plus tard ?',
            answer: 'Oui, vous pouvez ajuster vos prix et créer de nouveaux tarifs à tout moment. Les abonnements existants continueront à leur prix d\'origine.'
          },
          refunds: {
            question: 'Comment sont gérés les remboursements ?',
            answer: 'Les remboursements peuvent être émis via votre tableau de bord Stripe. La commission Videas est également remboursée lorsque vous traitez un remboursement.'
          }
        }
      }
    },
    activation: {
      step: 'Étape',
      previous: 'Précédent',
      next: 'Suivant',
      config: {
        title: 'Configurez Votre Monétisation',
        subtitle: 'Définissez vos préférences de paiement et informations fiscales',
        currency: {
          label: 'Devise de Paiement',
          helper: 'Choisissez la devise pour toutes vos transactions'
        },
        paymentMethods: {
          label: 'Méthodes de Paiement',
          helper: 'Sélectionnez les options de paiement à proposer à vos clients',
          subscriptions: 'Abonnements récurrents',
          purchases: 'Achats uniques',
          rentals: 'Locations limitées dans le temps',
          tips: 'Accepter les pourboires des spectateurs'
        },
        tax: {
          label: 'Informations Fiscales',
          helper: 'Requis pour la conformité fiscale et la facturation',
          country: 'Pays de l\'Entreprise',
          vatNumber: 'Numéro de TVA',
          vatPlaceholder: 'Optionnel (ex: FR12345678901)'
        }
      },
      stripe: {
        title: 'Connectez Votre Compte Stripe',
        subtitle: 'Stripe gère tout le traitement des paiements en toute sécurité',
        security: {
          title: 'Connexion Sécurisée',
          description: 'Vos informations bancaires sont gérées directement par Stripe, jamais stockées sur nos serveurs'
        },
        requirements: {
          identity: {
            title: 'Vérification d\'Identité',
            description: 'Identification personnelle ou professionnelle requise'
          },
          business: {
            title: 'Informations de l\'Entreprise',
            description: 'Détails de la société si applicable'
          },
          bank: {
            title: 'Compte Bancaire',
            description: 'Où vous recevrez vos paiements'
          },
          tax: {
            title: 'Détails Fiscaux',
            description: 'Pour une déclaration fiscale appropriée'
          }
        },
        connectButton: 'Se Connecter avec Stripe',
        redirectNotice: 'Vous serez redirigé vers Stripe pour terminer la configuration'
      },
      success: {
        title: 'Monétisation Activée !',
        subtitle: 'Votre chaîne est maintenant prête à générer des revenus',
        nextSteps: {
          title: 'Prochaines Étapes',
          createTariffs: 'Créez vos premiers plans tarifaires',
          setupSubscriptions: 'Configurez des offres d\'abonnement',
          addPromoCodes: 'Ajoutez des codes promotionnels',
          monitorSales: 'Surveillez votre tableau de bord des ventes'
        },
        finishButton: 'Aller aux Paramètres'
      }
    },
    settings: {
      status: {
        active: 'Monétisation Active',
        description: 'Votre chaîne est configurée pour accepter les paiements',
        viewDashboard: 'Voir le Tableau de Bord'
      },
      general: {
        title: 'Paramètres Généraux',
        currency: 'Devise',
        tips: 'Accepter les Pourboires',
        edit: 'Modifier les Paramètres'
      },
      stripe: {
        title: 'Compte Stripe',
        connected: 'Connecté',
        accountId: 'ID du Compte',
        dashboard: 'Ouvrir le Tableau de Bord Stripe'
      },
      quickActions: {
        title: 'Actions Rapides',
        subscriptions: 'Gérer les Abonnements',
        tariffs: 'Gérer les Tarifs',
        promoCodes: 'Codes Promo',
        reports: 'Rapports de Ventes'
      },
      danger: {
        title: 'Zone de Danger',
        warning: 'La désactivation de la monétisation arrêtera toutes les nouvelles ventes. Les abonnements existants continueront jusqu\'à leur expiration.',
        deactivate: 'Désactiver la Monétisation'
      }
    }
  },

  settings: {
    title: 'Réglages généraux',
    description: 'Gérez les paramètres et options relatives à votre chaîne.',
    tabs: {
      domain: 'Lien de la chaîne',
      seo: 'Nom de la chaîne et description',
      legal: 'Mentions légales / CGU - CGV',
      auth: "Système d'authentification",
      contact: 'Formulaire de contact',
      options: 'Options',
      monetization: 'Vente de vidéos',
    },
    seo: {
      channelName: 'Nom de la chaîne',
      channelDescription: 'Décrivez votre chaîne',
    },
    legal: {
      description:
        'Insérez vos éléments juridiques. Ils apparaitront dans le pied de page de votre chaîne.',
      sample:
        "*Ceci est du markdown :*\n# correspond à un titre\n## correspond à un sous-titre\n### et ainsi de suite\n**permet de mettre un texte en gras**\nPour plus d'exemples : https://stackedit.io/app#\n\n---------------------\n\n# Mentions légales\n\n## Editeur\nNom prénom\n11 rue des lilas\n59000 Lille\nhttps://monsite.fr\n\n## Hébergeur\nVIDEAS SAS\nhttps://videas.fr\n4702 Chemin de l’aventure\n59236 Frelinghien\nFRANCE\nSiret : 83435667700015\ncontact@videas.fr",
    },
    auth: {
      description:
        "Définissez si votre chaîne est accessible de manière privé ou publique. Vous avez la possibilité d'activer des comptes utilisateurs sur votre chaîne.",
      alert:
        "Une fois la monétisation activée, seul le mode d'authentification par utilisateur est autorisé.",
      text2:
        'Autoriser les utilisateurs à se connecter pour accéder à votre chaîne ou à vos contenus privés.',
      text3: 'Un bouton « connexion » apparaitra sur votre chaîne.',
      authEnable: "Activer l'authentification",
      chooseAuthMethod: 'Choisissez le mode de connexion',
      passwordMethod: 'Mot de passe unique',
      passwordText:
        " Les utilisateurs pourront se connecter à votre chaîne pour accéder aux contenus privés grâce au mot de passe que vous aurez défini ci-dessous. Le mot de passe est identique pour l'ensemble des utilisateurs.",
      usersMethod: 'Comptes utilisateurs',
      usersText:
        'Les utilisateurs pourront se connecter à votre chaîne pour accéder aux contenus privés grâce à un compte utilisateur (identifiant/mot de passe).',
      enableRegistration:
        "Autoriser les utilisateurs à s'inscrire sur la chaîne sans invitation de votre part.",
      forcedAuth: 'Authentification forcée',
      enableForcedAuth:
        "Les utilisateurs doivent obligatoirement s'authentifier pour accéder à votre chaîne.",
      auth: 'Auth',
      groupsUsers: "Groupes d'utilisateurs",
      passwordField:
        'Le mot de passe ci-dessous est à transmettre aux utilisateurs à qui vous souhaitez donner accès',
      enterPassword: 'Entrer un mot de passe',
      userRegistration: 'Inscription des utilisateurs',
      userRegistrationText:
        'Autoriser les utilisateurs à se créer un compte sur la chaîne, sans validation ni invitation de votre part.',
      required: 'Authentification obligatoire',
      requiredText:
        "En activant cette option, aucun contenu ne sera accessible publiquement.\nUniquement les personnes authentifiées pourront accéder à votre chaîne.\nUne page de connexion apparait directement lorsqu'une personne se rend sur l'adresse de votre chaîne.",
      loginPage: 'Page de connexion',
    },
    contact: {
      title: 'Formulaire de contact',
      description:
        'Définissez à quelle adresse vous souhaitez recevoir les emails du formulaires de contact présent sur la chaîne.',
      text: "Par défaut, les emails de contact sont envoyés sur l'adresse de votre compte. Pour envoyer sur une autre adresse, modifiez le chanmp ci-dessous.",
    },
    options: {
      switch1Title: 'Bouton Partager',
      switch1Text:
        "Ajoute un bouton en dessous de la vidéo qui permet aux utilisateurs de partager un lien ou d'intégrer le player sur un site externe",
      switch2Title: 'Commentaires',
      switch2Text:
        "Autorise les utilisateurs connectés à poster des commentaires sous vos médias. Les commentaires sont visibles par l'ensemble des utilisateurs.",
      switch3Title: 'Réception de contenus',
      switch3Text:
        'Autorise les utilisateurs à vous soumettre du contenu depuis la chaine. Les contenus soumis apparaitront dans votre bibliothèque et vous recevrez une notification à chaque nouvel envoi.',
      sellVideos: 'Vente de vidéos',
      switch4Text:
        "Vendez vos vidéos par abonnement ou à l'achat/location directement depuis votre chaîne.",
      monetizationSubtitle: 'Autoriser les utilisateurs à donner un don',
      monetizationText:
        "En activant cette option, un champ apparaitra au niveau du panier pour permettre à l'utilisateur de faire un don.",
      monetizationNote: 'A noter que cette fonctionnalité ne fonctionne pas pour les abonnements.',
      alert: "Vous pouvez suivre l'ensemble de vos ventes sur l'interface Stripe.",
    },
    newsLetter: {
      title: 'Email de newsletter',
      description: 'Envoie un email chaque mois aux utilisateurs abonnés à la newsletter.',
      btnTest: 'Envoyer un email test',
      btnTestDescription: "Un email de démo sera envoyé à l'administrateur",
    },
  },
}
